"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.package_id = exports.selectedAbi = void 0;
exports.selectedAbi = '06045';
exports.package_id = 'it.sparkasse.retail.mobile';
